import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { WizumenModel } from '../wizumen-models';

//Modal
@Component({
  selector: 'wizumen-detail',
  template: `
      <div class="wizumen-modal-content {{wizumenItem.wizumen_guide_href !== '' ? 'guide-content' : ''}} {{wizumenItem.wizumen_guide_href}}">
        <div *ngIf="!isWhiteLabel" class="wizumen-modal-banner flex justify-space-between" [style.background-image]="'url(' + bannerImageSrc + ')'" [style.color]="isChanchitoOff ? 'black' : 'white'">
          <span class="wizumen-modal-banner-content flex-column">
              <p class="wizumen-modal-banner-title -eva-3-bold">
                {{wizumenItem.modal_texts?.pig_title}}
              </p>
              <p class="wizumen-modal-banner-text">
                {{wizumenItem.modal_texts?.pig_text}}
              </p>
          </span>
          <img *ngIf="!isChanchitoOff" class="wizumen-modal-banner-image" src="//media.staticontent.com/media/pictures/d8f6eaa1-ed2d-4b41-9a3f-21b2af96db38" alt="wizumen"/>
        </div>

        <wizumen-guide *ngIf="wizumenItem.wizumen_guide_href"
          [WizumenGuide]="wizumenItem.wizumen_guide"
          [wizumenGuideHref]="wizumenItem.wizumen_guide_href"
          [toCityCode]="wizumenItem.to_city_code"
          [uniqueId]="uniqueId" [moduleId]="moduleId" [moduleIndex]="moduleIndex">
        </wizumen-guide>

        <div class="wizumen-modal-additionals wizumen-modal-additionals-{{wizumenItem.additionals.length}}">
            <wizumen-additional *ngFor="let additional of wizumenItem.additionals; let i = index"
              [uniqueId]="uniqueId" [moduleId]="moduleId" [moduleIndex]="moduleIndex"
              [wizumenAdditional]="additional" [index]="i + 1" [toCityCode]="wizumenItem.to_city_code">
            </wizumen-additional>
        </div>

        <div class="wizumen-modal-products -border-top">
          <span class="wizumen-modal-products-title flex justify-space-between align-center">
              <em class="wizumen-modal-products-text -eva-3-bold">
                  {{wizumenItem.modal_texts?.bought_products_title}}
              </em>
              <p class="wizumen-modal-account-link eva-3-link" (click)="handleMyTravelsClick()">
                  {{wizumenItem.modal_texts?.my_travels_link_text}}
              </p>
          </span>

          <div class="wizumen-modal-products-container">
            <wizumen-bought-product *ngFor="let bought of wizumenItem.bought" [item]="bought"></wizumen-bought-product>
          </div>
        </div>

      </div>
  `,
  styleUrls: ['wizumen-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizumenDetailComponent implements OnInit {
  @Input() wizumenItem: WizumenModel;
  @Input() myTravelsHref: string;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId: string;

  isWhiteLabel: boolean;

  isChanchitoOff: boolean;
  bannerImageSrc: string = "//media.staticontent.com/media/pictures/";
  pigBannerMediaKey: string = "f3d4674c-2be1-4f87-ae43-ae3073eec6dd";
  couponBannerMediaKey: string = "bff3e90c-1fd8-406b-a1ac-200d33ddc2c5";

  constructor(private upaService: UpaService, landingModelService: LandingModelService) {
    const landingModel = landingModelService.getLandingModel();

    this.isWhiteLabel = landingModel.whiteLabel;
    this.isChanchitoOff = landingModelService.getLandingModel().abTests?.ab.includes("ChanchitoOff|off_true");
  }

  ngOnInit(): void {
    this.bannerImageSrc += this.isChanchitoOff ? this.couponBannerMediaKey : this.pigBannerMediaKey;
  }

  handleMyTravelsClick(): void {
    this.trackMyTravelsClick();

    window.open(this.myTravelsHref, '_blank');
  }

  public trackMyTravelsClick() {
    this.upaService.trackClickTopic({
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      target: UpaTarget.WIZUMEN_MODAL,
      label: 'MV',
      href: this.myTravelsHref,
      dc: this.wizumenItem.to_city_code,
      uniqueId: this.uniqueId
    })
  }
}
